export default __webpack_public_path__ + "static/media/Scipio's Necklace of Protection.b71ddddc.jpg";